import React from "react";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <>
      <div className="container">
        <div id="top1" className="row">
          <div id="top1right" className="col-md-12 col-sm-12 col-xs-12 my-3">
            <h2>Privacy Policy</h2>
          </div>
        </div>
      </div>
      <div class="region region-content">
        <div id="block-system-main" class="block block-system">
          <div class="content">
            <div id="node-2551548" class="node node-panel clearfix">
              <div class="content">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12 inner-timeline">
                      <div class="panel-pane pane-node-body">
                        <div class="pane-content">
                          <div class="field field-name-body field-type-text-with-summary field-label-hidden">
                            <div class="field-items">
                              <div class="field-item even">
                                <p>
                                  Tgt Weddings is fully committed to
                                  protecting and respecting your
                                  privacy.&nbsp;This policy, together with our{" "}
                                  <a href="/terms" target="_blank">
                                    Terms of Use
                                  </a>
                                  &nbsp;sets out the basis on which any personal
                                  data we collect from you, or that you provide
                                  to us, will be processed by us.
                                </p>
                                <p>
                                  By using our Services, you agree that your
                                  personal information may be used in accordance
                                  with this Privacy Policy. Please carefully
                                  review this Privacy Policy and our Terms of
                                  Use and contact us if you have any questions.
                                </p>
                                <p>
                                  <strong>
                                    Collection and Use of Personal Information:
                                  </strong>
                                </p>
                                <p>
                                  Personal information is generally information
                                  that can reasonably be used to identify or
                                  contact you. When you use our Services, we may
                                  collect and store personal information about
                                  you to provide our Services to you and improve
                                  the Services we provide to all of our users.
                                  Below are some examples of personal
                                  information we collect and how we use it.
                                </p>
                                <p>
                                  <strong>
                                    Information You Provide Directly:
                                  </strong>
                                </p>
                                <ul>
                                  <li>
                                    <p>
                                      <strong>
                                        Registration and Account Information:
                                      </strong>
                                      &nbsp;When you register an account or fill
                                      out a form on the website, we may collect
                                      certain personal information, such as your
                                      first name, last name, your email address,
                                      and your telephone number. If you share
                                      personal information of others, such as
                                      your fiancé, you are representing that you
                                      are authorized to provide us with their
                                      information and that we may treat it in
                                      accordance with this Privacy Policy.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>
                                        Special Forms on the Site:
                                      </strong>{" "}
                                      When you submit the Get Offers Form and
                                      Order a Deal Form, for example, we may
                                      collect certain personal information such
                                      as your first name, last name, email
                                      address, phone number, wedding date,
                                      number of guests you intend to invite to
                                      your wedding and your wedding preferences.
                                      If you share personal information of
                                      others, such as your fiancé, you are
                                      representing that you are authorized to
                                      provide us with their information and that
                                      we may treat it in accordance with this
                                      Privacy Policy.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>Customer Services.</strong>
                                      &nbsp;When you contact us through any of
                                      our customer support channels, including
                                      email, web, and telephone, we may collect
                                      personal information to track and respond
                                      to your inquiry and analyze and improve
                                      our Services.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>Vendors Registration:</strong>
                                      &nbsp;When a Vendor submits a form to be
                                      listed in our online directories, or
                                      upgrade the standard/free listing to
                                      Premium, we may collect certain personal
                                      information such as your first name, last
                                      name, email address, phone number, company
                                      name, business activity and business
                                      address. For security purposes, Vendors
                                      should not include any payment card
                                      information or other sensitive data.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>Real Weddings:</strong> We only
                                      publish and share Real Weddings when you
                                      send us your wedding pictures and
                                      authorize us to publish your wedding on
                                      our website and/or our Social Media
                                      channels. Whenever you decide that you
                                      would like us to un-publish the wedding,
                                      we will respect your personal wishes and
                                      abide by them. We take no responsibility
                                      if your wedding pictures are screen shot,
                                      downloaded or copied by third parties and
                                      used for their own purposes.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>
                                        Third Party Services (e.g. Social
                                        Media):
                                      </strong>
                                      &nbsp;If you use a third party site, such
                                      as Facebook, Instagram, or Twitter, to
                                      create an account we may collect your
                                      first name, last name, email address,
                                      phone number and we may also collect other
                                      information (e.g. your gender, age,
                                      language, country…) depending on your
                                      privacy settings on the third-party site
                                      as permitted by such sites.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>Online surveys:</strong>&nbsp;From
                                      time to time, we may conduct surveys to
                                      collect information about user preferences
                                      and/or your wedding. These are optional,
                                      and if you choose to respond to them, your
                                      responses will be treated in accordance
                                      with this Privacy Policy and any other
                                      applicable policies or terms. These
                                      surveys may be conducted by and processed
                                      through third parties.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>Contests: </strong>We may offer
                                      contests where we request contact and
                                      demographic information such as name and
                                      email address. Information we gather
                                      through a contest may also be disclosed to
                                      third parties as necessary for prize
                                      fulfillment and other aspects of any
                                      contest or similar offering. Additionally,
                                      if we run a co-branded contest or survey
                                      with a partner, unless the survey or
                                      contest terms provide otherwise,
                                      information that you provide pursuant to
                                      that contest or survey may be provided to
                                      that partner, after which it will be
                                      subject to that partner’s privacy policy.
                                    </p>
                                  </li>
                                </ul>
                                <p>
                                  <strong>
                                    Information Collected During Use of Services
                                  </strong>
                                </p>
                                <ul>
                                  <li>
                                    <p>
                                      As is the case with many websites, our
                                      Services automatically collect information
                                      when you visit them, including, but not
                                      limited to, browser characteristics,
                                      operating system, settings, ISP, domain
                                      name, IP address, type of computer or
                                      mobile device, mobile carrier, connection
                                      information, and unique device identifier.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      We may collect information about how you
                                      use our Services, such as the types of
                                      content you view or engage with; the
                                      features you use; the actions you take;
                                      the people or accounts you interact with;
                                      and the time, frequency and duration of
                                      your activities. For example, we may log
                                      when you are using and have last used our
                                      Services, and what pages and other content
                                      you view on our Services. We use this
                                      information for a variety of purposes, to
                                      tailor the Services to your preferences
                                      and improve your experience, to operate
                                      and administer the Services, to conduct
                                      research and analytics, to assess your
                                      interest in the Services, to deliver
                                      advertisements that may interest you, and
                                      to keep the Services secure. We may deploy
                                      various tracking technologies to collect
                                      this information.
                                    </p>
                                  </li>
                                </ul>
                                <p>
                                  <strong>
                                    How We Use Your Personal Information
                                  </strong>
                                </p>
                                <p>
                                  The personal data collected through the
                                  website will only be used in relation to the
                                  services offered by TGT Weddings.
                                </p>
                                <p>
                                  We will use and share your personal
                                  information with third parties only in the
                                  ways described in this Privacy Policy.
                                </p>
                                <ul>
                                  <li>
                                    <p>
                                      <strong>
                                        Administer Our Site and Services:
                                      </strong>
                                      &nbsp;We use your personal information to
                                      conduct and fulfill the process that you
                                      request from our Services.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>Provide Customer Support:</strong>
                                      &nbsp;When you contact customer support,
                                      we may use or request personal information
                                      as necessary to answer your questions,
                                      resolve disputes, or investigate
                                      complaints.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>Send Communications:</strong>
                                      &nbsp;We may process your personal
                                      information to send you communications and
                                      e-newsletters. This may include contacting
                                      you via email, telephone, push
                                      notifications, WhatsApp messages or
                                      text-based messaging to inform you about
                                      updates to our Services, or information
                                      about your account, or information related
                                      to the Services you requested.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>Publish Testimonials:</strong>
                                      &nbsp;We may use personal information to
                                      post testimonials on our website and/or
                                      Social Media channels (eg Instagram,
                                      Facebook).
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>
                                        Conferences, Exhibitions and Events:{" "}
                                      </strong>
                                      We may use your personal information to
                                      communicate with you about our events or
                                      third party events, such as conferences
                                      and exhibitions. We may contact you about
                                      events and related services, and may share
                                      information about your attendance with
                                      third parties, where legally permitted to
                                      do so.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>
                                        Conduct Analytics, Research and
                                        Development:
                                      </strong>
                                      &nbsp;We may also use personal information
                                      for internal purposes such as data
                                      analysis, and research to improve our
                                      Services and customer communications, as
                                      well as to develop new products and
                                      offerings.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <strong>
                                        Send Ads and Other Sponsored Content:
                                      </strong>
                                      &nbsp;We may use personal information we
                                      obtain from you, your interactions with
                                      our Services to provide you with marketing
                                      and promotional communications, to deliver
                                      targeted and relevant advertising and
                                      marketing to you, to determine the
                                      effectiveness of our marketing and
                                      promotional campaigns, to better
                                      understand you and your preferences, and
                                      to position and promote our Services. You
                                      can unsubscribe from such emails by
                                      clicking “unsubscribe” link on the email
                                      footer or by contacting us directly
                                      through the{" "}
                                      <u>
                                        <a href="#">
                                          Contact Us
                                        </a>
                                      </u>{" "}
                                      form.
                                    </p>
                                  </li>
                                </ul>
                                <p>
                                  <strong>
                                    Disclosure of Your Information
                                  </strong>
                                </p>
                                <ul>
                                  <li>
                                    <p>
                                      We may disclose your personal information
                                      to third parties in very limited
                                      situations.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      We will share your personal information
                                      with Vendors to provide you with the
                                      requested wedding packages and proposals
                                      and other services you request, either
                                      through us or directly by the Vendors who
                                      may contact you with customized offers and
                                      messages.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      We may also share your personal
                                      information with third parties when you
                                      win a contest that you are taking part in.
                                    </p>
                                  </li>
                                </ul>
                                <p>&nbsp;</p>
                                <p>
                                  <strong>Retention Period</strong>
                                </p>
                                <p>
                                  We save your personal information at least
                                  until your account membership with us is
                                  terminated and you unsubscribe to email
                                  notifications. After termination of your
                                  membership your personal information may
                                  remain on our archived database and records.
                                </p>
                                <p>
                                  <strong>
                                    How We Protect Personal Information
                                  </strong>
                                </p>
                                <p>
                                  We understand how important your privacy is to
                                  you, which is why we maintain appropriate
                                  physical, technical and administrative
                                  safeguards to protect the security and
                                  confidentiality of the personal information
                                  you entrust to us. Please note, however, that
                                  with current technology, the security of your
                                  personal information as it travels over the
                                  Internet or as it resides in any storage
                                  system cannot be guaranteed to be completely
                                  secure.
                                </p>
                                <p>
                                  When you sign up for an account, you will
                                  establish a User ID and password. You are
                                  responsible for maintaining your password as
                                  confidential. You are responsible for any
                                  activity that occurs on your account as a
                                  result of you sharing your password with
                                  others or failing to protect it.
                                </p>
                                <h3>Security</h3>
                                <p>
                                  Arabia Weddings assures its users that all
                                  necessary means have been implemented, from a
                                  technological point of view, to guarantee the
                                  security of personal data and avoid loss,
                                  alteration or unauthorized processing.
                                </p>
                                <p>
                                  <strong>How to Contact Us</strong>
                                </p>
                                <p>
                                  If you have any question or comment regarding
                                  our privacy policy and practices email{" "}
                                  <u>
                                    <a href="#">
                                      info@tgt.com
                                    </a>{" "}
                                  </u>
                                  or use this form to the{" "}
                                  <u>
                                    <a href="#">
                                      Contact Us
                                    </a>
                                  </u>
                                  .
                                </p>
                              </div>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="top1" class="row">
                    <div
                      id="top1right"
                      class="col-md-12 col-sm-12 col-xs-12"
                    ></div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
